<template>
    <div>
        <CRow>
            <CCol md="12">

            </CCol>
        </CRow>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                       <CRow>
                        <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">
                            <strong>{{$t('salesPlan')}}</strong>

                        </CCol>

                        <CCol col="4" style="text-align: end">
                            <CButton @click="change_status_item_dialog()"
                                     class="mr-1"
                                     size="sm"
                                     color="secondary">
                                {{ $t('buttons.save') }}
                            </CButton>
                        </CCol>
                       </CRow>
                    </CCardHeader>
                    <CCardBody>
                        <CRow>

                            <CCol >
                                <CRow form class="form-group">
                                    <div tag="label" sm="4" class="col-form-label">
                                        {{$t('month')}}
                                    </div>
                                    <div sm="8">
                                        <date-picker
                                                v-if="$i18n.locale!='fa'"
                                                :label="$t('month')"
                                                type="month"
                                                input-format="MM"
                                                format="MM"
                                                alt-format="MM"

                                                display-format="MM MMM"
                                                :auto-submit="false"
                                                v-model="start_date"></date-picker>
                                        <date-picker
                                                v-if="$i18n.locale=='fa'"
                                                :label="$t('month')"
                                                type="month"
                                                display-format="jMM jMMM"
                                                format="MM"
                                                :auto-submit="false"
                                                v-model="start_date"></date-picker>
                                    </div>
                                </CRow>

                            </CCol>
                            <CCol >
                                <CSelect
                                        :label="$t('country')"
                                        :value.sync="selected_country"
                                        :options="country_items"
                                />
                            </CCol>
                            <CCol>
                                <CSelect
                                        :label="$t('components.province')"

                                        :options="province_items"
                                        :value.sync="selected_province"/>

                            </CCol>
                            <CCol >
                                <CSelect
                                        :label="$t('components.city')"

                                        :options="city_items"
                                        :value.sync="selected_city"/>

                            </CCol>
                            <CCol col="1">
                              <div></div>
                              <br>
                              <CButton @click="get_lists()" color="dark"
                                       size="sm">
                                <CIcon size="sm" name="cil-zoom"/>
                              </CButton>

                            </CCol>


                        </CRow>
                        <CDataTableFixed
                                :items="items"
                                :fields="fields"
                                height="350px"
                                :items-per-page="20"
                                hover
                                striped
                                @row-clicked="table_row_clicked"
                                border
                                sorter
                                pagination
                        >
                            <template #row="{item,index}">
                                <td>
                                    <p style="text-align: center">{{index+1}}</p>
                                </td>
                            </template>
                            <template #monthNo="{item}">
                                <td>
                                    <p style="text-align: center">{{get_month(item)}}</p>
                                </td>
                            </template>
                            <template #categoryId="{item}">
                                <td>
                                    <p style="text-align: center">
                                        {{category_items.filter(x=>x.value==item.categoryId)[0].label}}</p>
                                </td>
                            </template>
                            <template #country="{item}">
                                <td>
                                    <p style="text-align: center">
                                        {{country_items.filter(x=>x.value==item.country)[0].label}}</p>
                                </td>
                            </template>

                            <template #countyName="{item}">
                                <td>
                                    <p v-if="item.countyName!=null" style="text-align: center">{{item.countyName}}</p>
                                </td>
                            </template>
                            <template #cityName="{item}">
                                <td>
                                    <p v-if="item.cityName!=null" style="text-align: center">{{item.cityId}}</p>
                                </td>
                            </template>

                            <template #select-header="{item}">
                                <input type="checkbox" v-model="check_all_exit"
                                />
                            </template>
                            <template #select="{item}">
                                <td>
                                    <input v-if="item.statusId==0" type="checkbox" ref="permissions[]"
                                           v-model="id_checkbox_items"
                                           :value="item.masterId"/>
                                </td>
                            </template>

                        </CDataTableFixed>
                    </CCardBody>

                </CCard>
            </CCol>
        </CRow>
        <CModal
                :show.sync="show_factor_detail"
                :no-close-on-backdrop="true"
                :centered="true"
                :title="$t('InventoryBill')"
                size="lg"
                color="dark"
        >
            <CCard>
                <CCardHeader>
                    <!--                    <strong>{{ $t('ReturnDoc') }}</strong>-->

                </CCardHeader>
                <CCardBody>
                    <CDataTableFixed
                            :items="selected_factor_detail"
                            :fields="factor_product_fields"
                            striped
                            height="200px"
                            border
                            :items-per-page="200"
                            hover
                            pagination
                    >
                        <template #row="{item,index}">
                            <td>
                                <p style="text-align: center">{{index+1}}</p>
                            </td>
                        </template>
                        <template #amount="{item}">
                            <td>
                                <p style="text-align: right">{{item.amount}}</p>
                            </td>
                        </template>
                        <template #qty="{item}">
                            <td>
                                <p style="text-align: center">{{item.qty}}</p>
                            </td>
                        </template>
                        <template #productCode="{item}">
                            <td>
                                <p style="text-align: center">{{item.productCode}}</p>
                            </td>
                        </template>
                        <template #totalAmount="{item}">
                            <td>
                                <p style="text-align: right">{{item.totalAmount}}</p>
                            </td>
                        </template>
                        <template #currentSaleQty="{item}">
                            <td>
                                <p style="text-align: right">{{item.currentSaleQty}}</p>

                            </td>
                        </template>

                        <template #under-table>
                            <CRow>

                                <CCol></CCol>
                                <CCol></CCol>
                                <CCol></CCol>
                                <CCol></CCol>
                                <CCol></CCol>
                                <CCol>{{ $t('totalCirculation') }}</CCol>
                                <CCol>{{ get_currency(get_sum_credetor(selected_factor_detail)) }}</CCol>
                            </CRow>
                        </template>


                    </CDataTableFixed>


                </CCardBody>

            </CCard>


            <template #footer>
                <!--                <CButton v-if="selected_factor.statusId==0"-->
                <!--                         color="secondary"-->
                <!--                         @click="finalize_factor()"-->
                <!--                >{{ $t('Confirm') }}-->
                <!--                </CButton>-->
                <CButton
                        @click="show_factor_detail = false"
                        color="success"
                >{{ $t("buttons.close") }}
                </CButton>
            </template>
        </CModal>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import moment from 'moment-jalaali'

    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }

    export default {
        name: 'Login',
        components: {
            Treeselect,
        },
        data() {
            return {
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                show_factor_detail: false,
                selected_factor_detail: [],
                province_items: [],
                selected_province: 0,
                check_all_exit: false,
                id_checkbox_items: [],
                city_items: [],
                selected_city: 0,

                country_items: [],
                selected_country: 0,

                validate_errors: [],
                selected_product: null,
                name: '',
                start_date: '',
                file: '',
                color: '#ffffff',
                previewImage: '',
                description: '',
                category_items: [],
                selected_category: 0,
                items: [],
                fields: [
                    {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:5%'},
                    {key: 'monthNo', label: this.$t('month'), _style: 'width:10%'},
                    {key: 'categoryId', label: this.$t('productGroup'), _style: 'width:10%'},
                    {key: 'country', label: this.$t('country'), _style: 'width:10%;'},
                    {key: 'countyName', label: this.$t('components.province'), _style: 'width:10%;'},
                    {key: 'cityName', label: this.$t('components.city'), _style: 'width:10%;'},

                    {key: 'select', label: '', _style: 'width:5%;'},


                ],
                factor_product_fields: [
                    {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:5%'},
                    {key: 'productName', label: this.$t('item'), _style: 'width:20%'},
                    {key: 'productCode', label: this.$t('tables.code'), _style: 'width:10%'},
                    {key: 'qty', label: this.$t('currentSaleQty'), _style: 'width:10%;'},
                    {key: 'amount', label: this.$t('tables.amount'), _style: 'width:10%;'},
                    {key: 'totalAmount', label: '', _style: 'width:5%;'},
                ],
                table_clicks: 0,
                table_clicks_timer: null,
                document_person: null,

                details: [],
                collapseDuration: 0,
                status_form: 0,
                load_products({action, searchQuery, callback}) {
                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);

                            axios.post('GetProducts', formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;
                                callback(null, options);
                            })
                                .catch(function (error) {
                                    console.log(error);
                                });
                        })
                    }
                },
                normalizer_products(node) {
                    return {
                        id: node.id,
                        label: node.productCodeName,
                    }
                },
            }
        },
        created() {
        },
        mounted() {
            this.$root.root_validate_errors = [];


            this.start_date = moment().locale('en').format("MM");
            this.get_categories();
            this.get_country();
            this.get_lists();

            bus.$on("sales_plan_updated", (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();
                } else {
                    this.status_form = 0;
                }
            });
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.insert_data();

                } else {
                }
            });
        }, watch: {
            'check_all_exit': function () {
                if (this.check_all_exit) {
                    this.items.forEach(function (val) {
                        if (val.statusId == 0) {
                            this.id_checkbox_items.push(val.masterId)
                        }
                    })
                } else {
                    this.id_checkbox_items = [];
                }
            },
            'selected_province': function () {
                this.get_cities();
            },
            'selected_country': function () {
                this.get_provinces();
            },
        },
        methods: {
            change_status_item_dialog() {
                if (this.id_checkbox_items.length == 0) {
                    this.$root.root_validate_errors.push(this.$t('selectOne'));
                    return;
                }
                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("sureToConfirm"), [this.$t("dialogs.ok")], this.confirm_delete_name);
            },
            get_sum_credetor(list) {
                var sum = 0;
                list.forEach((val) => {
                    // if (val.currentSaleQty != null && val.amount != null) {
                    val.totalAmount = val.totalAmount.toString().replace(/,/g, '');
                    // val.currentSaleQty = val.currentSaleQty.toString().replace(/,/g, '');

                    sum += parseFloat(val.totalAmount);

                    // }
                })
                return sum;
            },

            table_row_clicked(item, index) {

                this.table_clicks++;
                if (this.table_clicks == 1) {
                    this.table_clicks_timer = setTimeout(() => {
                        // this.result.push(event.type);
                        this.table_clicks = 0
                    }, 500);
                } else if (this.table_clicks > 1) {
                    clearTimeout(this.table_clicks_timer);
                    this.show_factor_detail = true
                    this.selected_factor_detail = item.details
                }
            },
            get_month(item) {
                return moment(item.monthNo).locale('en').format("YYYY") + " - " + moment(item.monthNo).locale('en').format("MM")
            },
            get_category_products() {
                var self = this;
                const formData = new FormData();
                formData.append('id', this.selected_category);
                axios.post('GetProducts', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        content_data.data.forEach(function (val) {
                            self.items.push(val);
                        })
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
                    }
                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            get_country() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);


                axios.post('GetCountries', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        self.country_items = [];

                        self.country_items = self.sort_array(
                            self.country_items, content_data.data,
                            'id', 'title');

                        if (self.$i18n.locale == 'fa') {
                            self.selected_country = self.country_items.filter(x => x.label == 'ایران')[0].value
                        }
                        if (self.$i18n.locale == 'en') {
                            self.selected_country = self.country_items.filter(x => x.label == 'England')[0].value
                        }

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_provinces() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_country);


                axios.post('GetStateList', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.province_items = [];
                        self.province_items.push({label: self.$t('dialogs.insertProvince'), value: 0});

                        self.province_items = self.sort_array(
                            self.province_items, content_data.data,
                            'id', 'provinceName');


                        self.selected_province = self.province_items[0].value;

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_cities() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_province);

                axios.post('GetCityListByStateId', formData, {show_pros: true}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
                        //         fields;
                        self.city_items = []
                        self.city_items = self.sort_array(
                            self.city_items, content_data.data,
                            'cityId', 'cityName');

                        self.selected_city = self.city_items[0].value;

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_categories() {
                var self = this;


                const formData = new FormData();

                axios.post('GetAllCats', formData, {
                    params: {
                        // isparent : self.$route.params.cat_id
                    },
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('token')
                    }
                }).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
                        //         fields;
                        self.category_items = [];
                        var obj = {label: self.$t('dialogs.insertCategory'), value: 0}
                        self.category_items.push(obj);
                        self.category_items = self.sort_array(
                            self.category_items, content_data.data,
                            'catTitleId', 'catTitle');


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_lists() {
                var self = this;


                const formData = new FormData();

                axios.post('GetSalePlans ', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        self.items = content_data.data;

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            validateForm: function () {
                this.$root.root_validate_errors = [];

                if (this.document_person != '' && this.selected_area != 0) {
                    return true;
                }


                if (this.document_person == '') {
                    this.$root.root_validate_errors.push(this.$t('insertVisitorName'));
                }
                if (this.selected_area == 0) {
                    this.$root.root_validate_errors.push(this.$t('dialogs.insertArea'));
                }

                return false;
                // e.preventDefault();
            },
            goToAddTarget() {
                this.$router.push({path: "/dashboard/delivery/add-visitor-target"})
            },
            get_style(color) {
                return {
                    myStyle: {
                        backgroundColor: color
                    }
                }
            },

            insert_data() {

                if (!this.validateForm()) {
                    console.log("validate form is false" + this.validate_errors);
                    return true;
                }
                let self = this;
                const formData = new FormData();
                let url;
                if (this.status_form == 0) {
                    url = "AddSalePlanMasterStatus";
                }
                var json = [];
                self.id_checkbox_items.forEach(function (val) {
                    var product = self.items.filter(x => x.masterId == val)[0];
                    json.push({
                        MasterId: product.masterId,
                        StatusId: 1,
                    })
                })
                formData.append('Items', JSON.stringify(json));

                axios.post(url, formData, {}).then((res) => {

                    self.get_lists()
                    self.$root.modal_component.show_api_response_modals(res);

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            delete_item_dialog(item) {

                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

                this.status_form = this.items[item.row_id].id;

            },
            delete_item() {


                let self = this;
                const formData = new FormData()
                let url;
                url = "DeleteVisitorArea";


                formData.append('id', this.status_form);

                axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res);

                    self.status_form = 0;

                    self.get_lists();


                })
                    .catch(function (error) {

                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
        }
    }

</script>
